const environmentVariables = {
    apiHost: process.env.REACT_APP_API_HOST,
    apiPath: process.env.REACT_APP_API_PATH,
    apiPort: process.env.REACT_APP_API_PORT,
    apiScheme: process.env.REACT_APP_API_SCHEME,
};

export default environmentVariables;
